import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatRipple } from '@angular/material/core';
import { RxLet } from '@rx-angular/template/let'
import { Route } from '@angular/router'
import { rxState } from '@rx-angular/state';

@Component({
  selector: 'lib-button',
  standalone: true,
  imports: [CommonModule, RouterLink, RxLet, RouterLinkActive, MatRipple],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {

  private state = rxState<{ route: Route }>();
  readonly route$ = this.state.select('route');

  @Input()
  set route(route: Route) {
    this.state.set({route});
  }
}
